import * as protos from "../../assets/proto/compiled/all";
import { Money } from "../modules/main/util/interfaces";
import { Util } from "./util";
import protobuf from "protobufjs";

export class ProtoUtil {

    static moneyToNumber(proto: protos.waiternow.common.IMoneyProto) {
        if (!proto || !proto.cents) {
            return 0;
        }
        let strCents = '';
        if (proto.cents == 0) {
            strCents = '00';
        } else if(proto.cents < 10) {
            strCents = '0' + proto.cents;
        } else {
            strCents += proto.cents;
        }
        return parseFloat(proto.units + '.' + strCents);
    }

    static createTextProto(textEn?: string, textEs?: string): protos.waiternow.common.TextProto {
        const textProto = new protos.waiternow.common.TextProto();
        if (textEn) {
            textProto.text = textEn;
            textProto.language = protos.waiternow.common.Language.ENGLISH;
        if (textEs) {
            const localizedTextProto = new protos.waiternow.common.TextProto.LocalizedTextProto();
            localizedTextProto.text = textEs;
            localizedTextProto.language = protos.waiternow.common.Language.SPANISH;
            textProto.localizedTexts = new Array<protos.waiternow.common.TextProto.LocalizedTextProto>();
            textProto.localizedTexts.push(localizedTextProto);
        }
        } else if (textEs) {
            textProto.text = textEs;
            textProto.language = protos.waiternow.common.Language.SPANISH;
        }
        return textProto;
    }

    static pickerMoneyToMoneyProto(money: Money): protos.waiternow.common.MoneyProto {
        return ProtoUtil.createMoneyProto(money.units, money.cents, money.currencyCode);
    }

    static createMoneyProto(units: number, cents: number, currencyCode: string): protos.waiternow.common.MoneyProto {
        const moneyProto = new protos.waiternow.common.MoneyProto();
        moneyProto.currencyCode = currencyCode;
        moneyProto.units = units;
        moneyProto.cents = cents;
        return moneyProto;
    }

    static moneyProtoToPickerMoney(moneyProto: protos.waiternow.common.IMoneyProto, currencyCode: string): Money {
        const money: Money = {units: 0, cents: 0, currencyCode: currencyCode};
        if (moneyProto) {
            money.units = Util.safeNumber(Number(moneyProto.units));
            money.cents = Util.safeNumber(moneyProto.cents);
            money.currencyCode = Util.safeString(moneyProto.currencyCode);
        }
        return money;
    }

    static getText(textProto: protos.waiternow.common.ITextProto | null | undefined, language: protos.waiternow.common.Language): string {
        if (!textProto) {
            return '';
        }

        if (!language || textProto.language == language) {
            return Util.safeString(textProto.text);
        }

        if (textProto.localizedTexts) {
            for(const localizedText of textProto.localizedTexts) {
                if (localizedText.language == language) {
                    return Util.safeString(localizedText.text);
                }
            }
        }

        return Util.safeString(textProto.text);
    }

    static protoToString(protoMessage: object | null | undefined) {
        if (!protoMessage) {
        return '';
        }
        return JSON.stringify(protoMessage);
    }

    static async convertJsonToMenuProto(json: any) {
        try {
    
            // Load .proto files
            // protobufjs can load multiple fiels that import each other
            const root = await protobuf.load([
                "assets/proto/common.proto",
                "assets/proto/menu.proto"
            ]);
    
            // Look for MenuProto
            const MenuProto = root.lookupType("waiternow.common.MenuProto");

            // Verify if IA menu can be converted to MenuProto
            // Verify if enums and required fields are valid
            const errMsg = MenuProto.verify(json);
            if (errMsg) throw Error("Error validating Proto: " + errMsg);

            // Convert JSON plain object to proto class
            const message = MenuProto.fromObject(json);

            // Conversion to IMenuProto
            const finalMenu = message as protos.waiternow.common.IMenuProto;

            // Serialize binary (Uint8Array)
            // const buffer = MenuProto.encode(message).finish();

            // console.log("Buffer binary generated: ", buffer);

            // const base64Proto = btoa(String.fromCharCode(...buffer));

            return {
            message: message,
            // binary: buffer,
            finalMenu: finalMenu
            // base64: base64Proto
            };
    
        } catch (e) {
            console.error("Error converting JSON to Proto: ", e);
            throw e;
        }
    }
    
    static async convertJsonToMenuSpecProto(json: any) {
        try {
    
            // Load .proto files
            // protobufjs can load multiple fiels that import each other
            const root = await protobuf.load([
                "assets/proto/common.proto",
                "assets/proto/menu.proto"
            ]);
    
            // Look for MenuSpecProto
            const MenuSpecProto = root.lookupType("waiternow.common.MenuSpecProto");

            // Verify if IA menu can be converted to MenuSpecProto
            // Verify if enums and required fields are valid
            const errMsg = MenuSpecProto.verify(json);
            if (errMsg) throw Error("Error validating Proto: " + errMsg);

            // Convert JSON plain object to proto class
            const message = MenuSpecProto.fromObject(json);

            // Conversion to IMenuSpecProto
            const finalMenu = message as protos.waiternow.common.IMenuSpecProto;

            // Serialize binary (Uint8Array)
            // const buffer = MenuSpecProto.encode(message).finish();

            // console.log("Buffer binary generated: ", buffer);

            // const base64Proto = btoa(String.fromCharCode(...buffer));

            return {
            message: message,
            // binary: buffer,
            finalMenu: finalMenu
            // base64: base64Proto
            };
    
        } catch (e) {
            console.error("Error converting JSON to Proto: ", e);
            throw e;
        }
    }

    static async getDeepCopyFromMenuProto(proto: protos.waiternow.common.IMenuProto) {
        try {
            // Load .proto files
            // protobufjs can load multiple fiels that import each other
            const root = await protobuf.load([
                "assets/proto/common.proto",
                "assets/proto/menu.proto"
            ]);

            // Look for MenuProto
            const MenuProto = root.lookupType("waiternow.common.MenuProto");

            // Verifies that field values are valid and that required fields are present
            const errMsg = MenuProto.verify(proto);
            if (errMsg) throw Error("Error validating Proto: " + errMsg);

            // Create new deep copy
            const tempMessage = MenuProto.fromObject(proto);
            const plainObject = MenuProto.toObject(tempMessage, {
                defaults: true,
                arrays: true,
                objects: true,
                oneofs: true,
            });

            // Create new instance independent
            const message = MenuProto.fromObject(plainObject);
            
            // Conversion to IMenuProto
            const finalMenu = message as unknown as protos.waiternow.common.IMenuProto;

            // const buffer = MenuProto.encode(message).finish();

            return {
                message: message,
                // binary: buffer,
                finalMenu: finalMenu
                // base64: base64Proto
            };
    
        } catch (e) {
            console.error("Error creating deep copy of proto: ", e);
            throw e;
        }
    }

    static async getDeepCopyFromMenuSpecProto(proto: protos.waiternow.common.IMenuSpecProto) {
        try {
    
            // Load .proto files
            // protobufjs can load multiple fiels that import each other
            const root = await protobuf.load([
                "assets/proto/common.proto",
                "assets/proto/menu.proto"
            ]);

            // Look for StructuredMenuSpecProto
            const MenuSpecProto = root.lookupType("waiternow.common.MenuSpecProto");

            // Verifies that field values are valid and that required fields are present
            const errMsg = MenuSpecProto.verify(proto);
            if (errMsg) throw Error("Error validating Proto: " + errMsg);

            // Create new deep copy
            const tempMessage = MenuSpecProto.fromObject(proto);
            const plainObject = MenuSpecProto.toObject(tempMessage, {
                defaults: true,
                arrays: true,
                objects: true,
                oneofs: true,
            });

            // Create new instance independent
            const message = MenuSpecProto.fromObject(plainObject);
            
            // Conversion to IMenuSpecProto
            const finalMenu = message as unknown as protos.waiternow.common.IMenuSpecProto;

            // const buffer = MenuSpecProto.encode(message).finish();

            return {
                message: message,
                // binary: buffer,
                finalMenu: finalMenu
                // base64: base64Proto
            };
    
        } catch (e) {
            console.error("Error creating deep copy of proto: ", e);
            throw e;
        }
    }
}